
<mat-form-field>
  <input aria-label="Filter" matInput (keyup)="applyFilter($event.target.value)" i18n-placeholder="@@filter"
         placeholder="Filter">
</mat-form-field>
<mat-paginator [length]="totalNumberOfItems ?? 0  " [pageSize]="pageSize"
               [pageSizeOptions]="[5, 10, 20, 50]"
 />
<div class="table-container mat-elevation-z2">
  <table mat-table class="table-list" matSort [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell i18n="@@customerName" *matHeaderCellDef mat-sort-header>Customer Name</th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>
    <ng-container matColumnDef="place">
      <th mat-header-cell i18n="@@place" *matHeaderCellDef mat-sort-header>Place</th>
      <td mat-cell *matCellDef="let element"> {{element.city}} </td>
    </ng-container>
    <ng-container matColumnDef="nip">
      <th mat-header-cell i18n="@@nip" *matHeaderCellDef>NIP</th>
      <td mat-cell *matCellDef="let element"> {{element.nip}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index;"
        [ngClass]="{'selected': selectedRowIndex === i}"
        (click)="selectCustomer(row, i)">
    </tr>

  </table>
</div>


